import { render } from "./LanguageDropdown.vue?vue&type=template&id=3e1895cc&scoped=true"
import script from "./LanguageDropdown.vue?vue&type=script&lang=js"
export * from "./LanguageDropdown.vue?vue&type=script&lang=js"

import "./LanguageDropdown.vue?vue&type=style&index=0&id=3e1895cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e1895cc"]])

export default __exports__